import {
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/user-external-accounts/constants';
import type { MessageRateLimitCapacityApi } from '@/modules/user-external-accounts/types';

import { userExternalAccountsQueryKeys } from './queryKeys';

export const useMessageRateLimitCapacityQuery = (
  userExternalAccountId: string | undefined,
  options?: Omit<
    UseQueryOptions<MessageRateLimitCapacityApi | undefined, unknown>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: userExternalAccountsQueryKeys.messageRateLimitCapacity(
      userExternalAccountId,
    ),
    queryFn: userExternalAccountId
      ? async () => {
          const { data } = await fetchClient.GET(
            endpoints.messageRateLimitCapacity,
            {
              params: {
                query: {
                  userExternalAccountId,
                },
              },
            },
          );

          return data;
        }
      : skipToken,
    ...options,
  });
};
